export const getAvailableFilters = (reviews) => {
	const departments = [];
	const states = [];
	const makes = [];
	reviews.forEach(({ review }) => {
		const {
			department: { _text: department },
			author: {
				_attributes: { state }
			},
			vehicle: {
				_attributes: { make }
			}
		} = review;
		if (department && !departments.includes(department)) {
			departments.push(department);
		}
		if (state && !states.includes(state)) {
			states.push(state);
		}
		if (make && !makes.includes(make)) {
			makes.push(make);
		}
	});
	return [
		{ type: 'department', values: departments },
		{ type: 'state', values: states },
		{ type: 'make', values: makes }
	];
};
